import PageDetector from '@/utils/PageDetector'
import BrowserStorage from '@/utils/BrowserStorage'
import GTM from '@/utils/tracking/gtm'
import { GA4_ADD_TO_WISHLIST } from '@/utils/constants/ga4'
import { MJ_SHARE_BUTTON_CLICK } from '@/utils/constants/gaCustomEventSet'
const INTERNAL_SERVER_ERROR_MESSAGE = '一時的なエラーが発生しました'
const EVENT_ENDED_MESSAGE = 'このイベントは終了いたしました'
const EVENT_CANCELLED_MESSAGE = 'このイベントは中止になりました。'
const BOOKMARK_FAILED_MESSAGE = 'お気に入り登録に失敗しました'
export default {
  props: {
    event: { type: Object, required: true, default: null },
    confirmFavRemoval: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      localStorageKey: 'event_bookmarks'
    }
  },
  computed: {
    stateBookmarkedEvents() {
      return this.$store.$state.bookmark_events
    },
    isBookmarked() {
      if (this.event && this.stateBookmarkedEvents && typeof this.stateBookmarkedEvents.includes === 'function') {
        return this.stateBookmarkedEvents.includes(this.event.id)
      }
      return false
    },
    localStorage() {
      return new BrowserStorage('localStorage')
    },
    pageDetector() {
      return new PageDetector(this.$route)
    }
  },
  methods: {
    bookmarkEvent(eventId) {
      const beforeCount = this.$store.bookmarkEventsCount
      if (this.$store.isLoggedIn) {
        this.$store
          .dispatch('bookmarkEvent', { event_id: eventId })
          .then(_res => {
            this.$store.BOOKMARK_EVENT(eventId)
            this.$emit('add-bookmark')
            this.displayBookmarkEventsNotificationModal(beforeCount, this.$store.bookmarkEventsCount)
          })
          .catch(e => {
            if (e.response.status === 404) alert(BOOKMARK_FAILED_MESSAGE)
            if (e.response.status === 422) alert(EVENT_ENDED_MESSAGE)
          })
      } else {
        this.$store.getBookmarkedEvents({ isLoggedIn: false, eventIds: [eventId] }).then(response => {
          if (response.data.events && response.data.events.length) {
            const bookmarkedEvents = this.localStorage.getItem(this.localStorageKey) ? this.localStorage.getItem(this.localStorageKey).split(',') : []
            bookmarkedEvents.push(eventId)
            const setItem = this.localStorage.setItem(this.localStorageKey, bookmarkedEvents.join())
            if (setItem === undefined) {
              this.$store.BOOKMARK_EVENT(eventId)
              this.displayBookmarkEventsNotificationModal(beforeCount, this.$store.bookmarkEventsCount)
            } else {
              alert(BOOKMARK_FAILED_MESSAGE)
            }
          } else {
            alert(EVENT_ENDED_MESSAGE)
          }
        })
      }
    },
    removeEventBookmark(eventId) {
      if (this.$store.isLoggedIn) {
        this.$store
          .removeEventBookmark(eventId)
          .then(_res => {
            this.$store.BOOKMARK_EVENT(eventId)
            this.$emit('remove-bookmark')
          })
          .catch(e => {
            if (e.response.status === 500) alert(INTERNAL_SERVER_ERROR_MESSAGE)
          })
      } else {
        const bookmarkedEvents = this.localStorageBookmarkedEventIds()
        if (!bookmarkedEvents) return
        const index = bookmarkedEvents.indexOf(eventId)
        if (index !== -1) {
          bookmarkedEvents.splice(index, 1)
          this.localStorage.setItem(this.localStorageKey, bookmarkedEvents.join())
          this.$store.BOOKMARK_EVENT(eventId)
        }
      }
    },
    toggleBookmark(e) {
      e.preventDefault()
      if (!this.event || this.pageDetector.isEventPreviewPage) return
      if (this.event.status === 'cancelled' && this.$store.isSP) {
        alert(EVENT_CANCELLED_MESSAGE)
        return
      }
      if (this.isBookmarked) {
        if (this.confirmFavRemoval) return
        this.removeEventBookmark(this.event.id)
      } else {
        this.pushGtmData()
        this.bookmarkEvent(this.event.id)
      }
    },
    shareSnsModal() {
      const payload = { event: this.event }
      this.$store.MODAL({ name: 'ShareSnsModal', payload })
      GTM.sendEventToGa({ ...MJ_SHARE_BUTTON_CLICK, label: 'フッターのSNS共有アイコン' })
    },
    displayBookmarkEventsNotificationModal(beforeCount, afterCount) {
      if (this.$store.isSP && beforeCount === 2 && afterCount === 3 && !this.pageDetector.isEventDetailPage) {
        this.$store.MODAL({ name: 'BookmarkEventsNotificationModal' })
      }
    },
    localStorageBookmarkedEventIds() {
      if (!this.localStorage.getItem(this.localStorageKey)) return []
      return this.localStorage
        .getItem(this.localStorageKey)
        .split(',')
        .map(v => parseInt(v))
    },
    pushGtmData() {
      GTM.sendEcommerceDataToGa(GA4_ADD_TO_WISHLIST, this.event, this.$store.myGender)
    }
  }
}
